import { render, staticRenderFns } from "./RaceForm.vue?vue&type=template&id=4ddc1c2a&scoped=true&"
import script from "./RaceForm.vue?vue&type=script&lang=js&"
export * from "./RaceForm.vue?vue&type=script&lang=js&"
import style0 from "./RaceForm.vue?vue&type=style&index=0&id=4ddc1c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddc1c2a",
  null
  
)

export default component.exports